import createModel, { prop } from '../lib/create_model';

export default createModel({
  modelName: 'ExternalCustomerAddress',
  properties: {
    id: prop(String).isRequired,
    type: prop(ExternalCustomerAddressType).isRequired, // type of address i.e. Twitter, Whatsapp
    displayName: prop(String).isRequired, // display name to show
  },
});

export const ExternalCustomerAddressType = Object.freeze({
  INSTAGRAM_DIRECT: 'INSTAGRAM_DIRECT',
  TWITTER: 'TWITTER',
  WHATSAPP: 'WHATSAPP',
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/customer_profile/external_customer_address.js